"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformFirebaseUser = void 0;
const firebase_adapter_1 = require("@ht-web/firebase-adapter");
const auth_1 = require("firebase/auth");
const vue_1 = __importDefault(require("vue"));
const Login_vue_1 = __importDefault(require("./pages/Login.vue"));
const transformFirebaseUser = (user) => {
    var _a, _b, _c, _d;
    if (user == null)
        return null;
    return {
        email: (_a = user.email) !== null && _a !== void 0 ? _a : '',
        uid: (_b = user.uid) !== null && _b !== void 0 ? _b : '',
        name: (_c = user.displayName) !== null && _c !== void 0 ? _c : '',
        profile: null,
        picture: (_d = user.photoURL) !== null && _d !== void 0 ? _d : ''
    };
};
exports.transformFirebaseUser = transformFirebaseUser;
class VueGoogleSignin {
    constructor() {
        this.isLoggedIn = false;
        this.lastRoute = null;
        this.authInitialized = false;
        this.userSnap = null;
    }
    authStateChange(vue) {
        (0, auth_1.onAuthStateChanged)(this.auth, (user) => {
            var _a;
            this.authInitialized = true;
            const isNowLoggedIn = user != null;
            const loginStateChanged = this.isLoggedIn !== isNowLoggedIn;
            this.isLoggedIn = isNowLoggedIn;
            (_a = this.userSnap) === null || _a === void 0 ? void 0 : _a.call(this);
            const newUser = (0, exports.transformFirebaseUser)(user);
            vue_1.default.set(vue.prototype.$auth, 'authInitialized', this.authInitialized);
            vue_1.default.set(vue.prototype.$auth, 'user', newUser);
            if (this.onAuthStateChanged != null) {
                this.onAuthStateChanged(newUser);
            }
            if (user != null) {
                this.userSnap = firebase_adapter_1.UserProfile
                    .byId(user.uid)
                    .listen(snap => {
                    const user = vue.prototype.$auth.user;
                    if (user != null) {
                        user.profile = snap !== null && snap !== void 0 ? snap : null;
                    }
                    vue_1.default.set(vue.prototype.$auth, 'user', user);
                });
            }
            if (!this.isLoggedIn) {
                this.router.push('/').catch(console.error);
                return;
            }
            if (this.lastRoute != null) {
                this.router.push(this.lastRoute).catch(console.error);
                this.lastRoute = null;
                return;
            }
            if (loginStateChanged) {
                this.router.push('/').catch(console.error);
            }
        });
    }
    async signOut() {
        await (0, auth_1.signOut)(this.auth);
        await this.router.push('/login');
    }
    install(vue, options) {
        if (typeof options !== 'object') {
            throw new Error('firebaseAuth and router options required');
        }
        this.router = options.router;
        this.auth = options.firebaseAuth;
        this.onAuthStateChanged = options.onAuthStateChanged;
        this.router.addRoute({
            path: '/login',
            name: 'login',
            component: Login_vue_1.default,
            props: {
                auth: options.firebaseAuth,
                appName: options.appName
            }
        });
        this.router.beforeEach((to, from, next) => {
            var _a;
            if (!this.authInitialized) {
                if (to.path === '/login')
                    return;
                this.lastRoute = {
                    params: to.params,
                    name: (_a = to.name) !== null && _a !== void 0 ? _a : undefined,
                    hash: to.hash,
                    path: to.fullPath,
                    query: to.query
                };
                return next('/login');
            }
            if (!this.isLoggedIn && to.path !== '/login') {
                return next('/login');
            }
            next();
        });
        const auth = vue_1.default.observable({
            authInitialized: false,
            signOut: async () => await this.signOut(),
            user: null
        });
        vue.prototype.$auth = auth;
        this.authStateChange(vue);
    }
}
exports.default = VueGoogleSignin;
